import React from 'react';
import { Card, CardContent } from '../components/ui/card';
import { Badge } from '../components/ui/badge';
import { CheckCircle2, TrendingUp } from 'lucide-react';
import { caseStudies } from '../mock';

export const CaseStudies = () => {
  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="pt-32 pb-16 bg-gradient-to-br from-slate-50 via-blue-50 to-teal-50">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-5xl md:text-7xl font-light tracking-tight mb-6">
              Case Studies
            </h1>
            <p className="text-xl md:text-2xl text-gray-600 font-light">
              Real-world success stories and measurable results
            </p>
          </div>
        </div>
      </section>

      {/* Case Studies */}
      <section className="py-24 bg-white">
        <div className="container mx-auto px-6">
          <div className="space-y-24">
            {caseStudies.map((study, index) => (
              <div key={study.id}>
                <Card className="border-0 shadow-2xl overflow-hidden">
                  <div className="grid grid-cols-1 lg:grid-cols-2">
                    <div className="relative aspect-video lg:aspect-auto">
                      <img
                        src={study.image}
                        alt={study.title}
                        className="w-full h-full object-cover"
                      />
                      <div className="absolute inset-0 bg-gradient-to-br from-blue-600/20 to-teal-600/20" />
                    </div>
                    
                    <CardContent className="p-8 lg:p-12">
                      <Badge className="mb-4">{study.industry}</Badge>
                      <h2 className="text-3xl font-light mb-6">{study.title}</h2>
                      
                      <div className="space-y-6">
                        <div>
                          <h3 className="text-sm font-semibold text-gray-500 uppercase mb-2">Challenge</h3>
                          <p className="text-gray-700">{study.challenge}</p>
                        </div>

                        <div>
                          <h3 className="text-sm font-semibold text-gray-500 uppercase mb-2">Solution</h3>
                          <p className="text-gray-700">{study.solution}</p>
                        </div>

                        <div>
                          <h3 className="text-sm font-semibold text-gray-500 uppercase mb-3 flex items-center">
                            <TrendingUp size={16} className="mr-2" />
                            Results
                          </h3>
                          <div className="space-y-2">
                            {study.results.map((result, idx) => (
                              <div key={idx} className="flex items-start space-x-2">
                                <CheckCircle2 size={18} className="text-green-600 mt-0.5 flex-shrink-0" />
                                <span className="text-gray-700">{result}</span>
                              </div>
                            ))}
                          </div>
                        </div>

                        <div>
                          <h3 className="text-sm font-semibold text-gray-500 uppercase mb-3">Technologies</h3>
                          <div className="flex flex-wrap gap-2">
                            {study.technologies.map((tech, idx) => (
                              <Badge key={idx} variant="outline">{tech}</Badge>
                            ))}
                          </div>
                        </div>
                      </div>
                    </CardContent>
                  </div>
                </Card>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Stats Banner */}
      <section className="py-16 bg-gradient-to-r from-blue-600 to-teal-600 text-white">
        <div className="container mx-auto px-6">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
            <div>
              <div className="text-4xl font-light mb-2">95%</div>
              <div className="text-sm opacity-90">Client Satisfaction</div>
            </div>
            <div>
              <div className="text-4xl font-light mb-2">150+</div>
              <div className="text-sm opacity-90">Projects Delivered</div>
            </div>
            <div>
              <div className="text-4xl font-light mb-2">3x</div>
              <div className="text-sm opacity-90">Average ROI Increase</div>
            </div>
            <div>
              <div className="text-4xl font-light mb-2">24/7</div>
              <div className="text-sm opacity-90">Support Available</div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};